import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { RiErrorWarningLine, RiRefreshLine, RiHome4Line } from '@remixicon/react';

/**
 * ROTA HATA SINIRI.
 *
 * NEDEN GEREKLİ: React Router, yakalanmayan bir hatada varsayılan olarak
 * HAM YIĞIN İZİNİ (stack trace) ekrana basar. Bu, geliştirme sırasında
 * yararlıdır ama son kullanıcıya gösterildiğinde iki zarar verir:
 *
 *   1. Kullanıcı ne yapacağını bilemez — sayfa "bozuldu" ve elinde bir
 *      seçenek yok.
 *   2. Dosya yolları ve iç yapı görünür hale gelir.
 *
 * Buradaki ekran kullanıcıya iki somut çıkış yolu verir (yenile / panoya
 * dön) ve teknik ayrıntıyı yalnızca geliştirme ortamında, katlanmış
 * biçimde gösterir.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  const isNotFound = isRouteErrorResponse(error) && error.status === 404;

  const title = isNotFound ? 'Sayfa bulunamadı' : 'Beklenmeyen bir hata oluştu';
  const description = isNotFound
    ? 'Aradığınız sayfa taşınmış veya hiç var olmamış olabilir.'
    : 'İşleminiz tamamlanamadı. Sayfayı yenilemeyi deneyin; sorun sürerse sistem yöneticinize bildirin.';

  const detail =
    error instanceof Error
      ? `${error.name}: ${error.message}`
      : isRouteErrorResponse(error)
        ? `${error.status} ${error.statusText}`
        : String(error);

  return (
    <div className="app-page">
      <div className="error-boundary">
        <span className="error-boundary__icon">
          <RiErrorWarningLine size={28} aria-hidden="true" />
        </span>

        <h1 className="error-boundary__title">{title}</h1>
        <p className="error-boundary__text">{description}</p>

        <div className="d-flex gap-2 justify-content-center flex-wrap">
          <button
            type="button"
            className="btn btn-sm btn-primary d-inline-flex align-items-center gap-1"
            onClick={() => window.location.reload()}
          >
            <RiRefreshLine size={15} aria-hidden="true" />
            Sayfayı Yenile
          </button>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
            onClick={() => navigate('/dashboard')}
          >
            <RiHome4Line size={15} aria-hidden="true" />
            Panoya Dön
          </button>
        </div>

        {import.meta.env.DEV && (
          <details className="error-boundary__detail">
            <summary>Teknik ayrıntı (yalnızca geliştirme)</summary>
            <pre>{detail}</pre>
          </details>
        )}
      </div>
    </div>
  );
}
